package com.shadowings.gero.data.lessons.chapter16

import com.shadowings.gero.data.lessons.DistractorPool
import com.shadowings.gero.data.lessons.buildAdverbialSentenceSync
import com.shadowings.gero.data.lessons.buildImperfectiveSentenceSync
import com.shadowings.gero.data.lessons.chapter11.buildPseudoverbalObjectSentence
import com.shadowings.gero.data.lessons.chapter11.buildWordBankFromWords
import com.shadowings.gero.data.lessons.distinctBaseWordCount
import com.shadowings.gero.data.lessons.possessiveForms
import com.shadowings.gero.data.repository.DatabaseRepositoryImpl
import com.shadowings.gero.data.repository.PossessivePairs
import com.shadowings.gero.data.repository.SentenceOptions
import com.shadowings.gero.data.repository.SentenceResult
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.WordSelectionContent
import com.shadowings.gero.presentation.model.Verb
import com.shadowings.gero.presentation.model.Word
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_in_viaggio_sul_nilo_1
import gero.composeapp.generated.resources.exp_content_in_viaggio_sul_nilo_10
import gero.composeapp.generated.resources.exp_content_in_viaggio_sul_nilo_11
import gero.composeapp.generated.resources.exp_content_in_viaggio_sul_nilo_12
import gero.composeapp.generated.resources.exp_content_in_viaggio_sul_nilo_13
import gero.composeapp.generated.resources.exp_content_in_viaggio_sul_nilo_14
import gero.composeapp.generated.resources.exp_content_in_viaggio_sul_nilo_2
import gero.composeapp.generated.resources.exp_content_in_viaggio_sul_nilo_3
import gero.composeapp.generated.resources.exp_content_in_viaggio_sul_nilo_4
import gero.composeapp.generated.resources.exp_content_in_viaggio_sul_nilo_5
import gero.composeapp.generated.resources.exp_content_in_viaggio_sul_nilo_6
import gero.composeapp.generated.resources.exp_content_in_viaggio_sul_nilo_7
import gero.composeapp.generated.resources.exp_content_in_viaggio_sul_nilo_8
import gero.composeapp.generated.resources.exp_content_in_viaggio_sul_nilo_9
import gero.composeapp.generated.resources.exp_title_in_viaggio_sul_nilo
import kotlin.random.Random

fun getInViaggioSulNiloContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_in_viaggio_sul_nilo,
            content = Res.string.exp_content_in_viaggio_sul_nilo_1,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_in_viaggio_sul_nilo,
            content = Res.string.exp_content_in_viaggio_sul_nilo_2,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_in_viaggio_sul_nilo,
            content = Res.string.exp_content_in_viaggio_sul_nilo_3,
            face = Faces.Idle,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_in_viaggio_sul_nilo,
            content = Res.string.exp_content_in_viaggio_sul_nilo_4,
            face = Faces.Idle,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_in_viaggio_sul_nilo,
            content = Res.string.exp_content_in_viaggio_sul_nilo_5,
            face = Faces.Doubt,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_in_viaggio_sul_nilo,
            content = Res.string.exp_content_in_viaggio_sul_nilo_6,
            face = Faces.Idle,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_in_viaggio_sul_nilo,
            content = Res.string.exp_content_in_viaggio_sul_nilo_7,
            face = Faces.Idle,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_in_viaggio_sul_nilo,
            content = Res.string.exp_content_in_viaggio_sul_nilo_8,
            face = Faces.Happy,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_in_viaggio_sul_nilo,
            content = Res.string.exp_content_in_viaggio_sul_nilo_9,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_in_viaggio_sul_nilo,
            content = Res.string.exp_content_in_viaggio_sul_nilo_10,
            face = Faces.Happy,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_in_viaggio_sul_nilo,
            content = Res.string.exp_content_in_viaggio_sul_nilo_11,
            face = Faces.Happy,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_in_viaggio_sul_nilo,
            content = Res.string.exp_content_in_viaggio_sul_nilo_12,
            face = Faces.Doubt,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_in_viaggio_sul_nilo,
            content = Res.string.exp_content_in_viaggio_sul_nilo_13,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_in_viaggio_sul_nilo,
            content = Res.string.exp_content_in_viaggio_sul_nilo_14,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
    )
}

// Chapter recap on whole sentences: random verbal (sḏm.f), pseudoverbal (iw sꜣ.i ḥr wnm t) and
// adverbial sentences from the existing builders. Each sentence draws whether its subject (wnm sꜣ.i t "mio figlio mangia il pane") and,
// in the verbal ones, its object (wnm sš t.f "lo scriba mangia il suo pane") get a suffix
// possessive; the builder then only picks nouns that can take one.
fun getInViaggioSulNiloQuizContent(
    words: List<Word>,
    verbs: List<Verb>,
    languageCode: String,
    verbSentences: List<SentenceOptions> = emptyList(),
    random: Random = Random,
    adverbialSentences: List<SentenceOptions> = DatabaseRepositoryImpl.adverbialSentences,
    possessivePairs: List<PossessivePairs> = DatabaseRepositoryImpl.possessivePairs
): List<IQuizContent> {
    val effectiveVerbSentences = verbSentences.ifEmpty { DatabaseRepositoryImpl.verbSentences }
    // Verbal rows come already filtered on seen words; adverbial ones are filtered here.
    val allowedIds = DistractorPool.words(words).map { it.id }.toSet()
    val effectiveAdverbials = adverbialSentences
        .map { row -> row.copy(subjects = row.subjects.filter { it in allowedIds }, places = row.places.filter { it in allowedIds }) }
        .filter { it.subjects.isNotEmpty() && it.places.isNotEmpty() }
    val hasObjects = effectiveVerbSentences.any { distinctBaseWordCount(it.objects, words) >= 1 }

    fun SentenceResult.translation(): String = when (languageCode) {
        "it" -> translationIt
        "de" -> translationDe
        "es" -> translationEs
        "fr" -> translationFr
        else -> translationEn
    }

    val sentences = mutableListOf<SentenceResult>()
    fun addDistinct(count: Int, build: () -> SentenceResult) {
        repeat(count) {
            var candidate: SentenceResult? = null
            for (attempt in 0 until 10) {
                candidate = build()
                if (sentences.none { it.translation() == candidate.translation() }) break
            }
            candidate?.let { sentences.add(it) }
        }
    }

    // 4 sḏm.f, 3 ḥr + infinitive and 3 adverbial; without adverbial rows 6 and 4. The ḥr ones need
    // an object (their builder always has one).
    val pseudoverbalCount = if (hasObjects) (if (effectiveAdverbials.isEmpty()) 4 else 3) else 0
    val verbalCount = (if (effectiveAdverbials.isEmpty()) 10 else 7) - pseudoverbalCount
    // Every sentence with an object has at least one possessive: on the subject, on the object, on
    // the object's owner ("l'acqua di tuo padre"), or on the subject and one of the others.
    val possessiveCombos = listOf(
        Triple(true, false, false), Triple(false, true, false), Triple(true, true, false),
        Triple(false, false, true), Triple(true, false, true)
    )
    if (effectiveVerbSentences.isNotEmpty()) {
        addDistinct(verbalCount) {
            val oggettiCount = if (hasObjects && random.nextBoolean()) 1 else 0
            val (onSubject, onObject, onOwner) = if (oggettiCount == 0) Triple(true, false, false)
                else possessiveCombos.random(random)
            buildImperfectiveSentenceSync(
                soggettiCount = 1,
                oggettiCount = oggettiCount,
                random = random,
                verbSentences = effectiveVerbSentences,
                words = words,
                verbs = verbs,
                subjectHavePossessive = onSubject,
                possessivePairs = possessivePairs,
                objectHavePossessive = onObject,
                objectPossessorHavePossessive = onOwner
            )
        }
    }
    if (pseudoverbalCount > 0) {
        addDistinct(pseudoverbalCount) {
            val (onSubject, onObject, onOwner) = possessiveCombos.random(random)
            val sentence = buildPseudoverbalObjectSentence(
                verbs = verbs,
                words = words,
                random = random,
                verbSentences = effectiveVerbSentences,
                subjectHavePossessive = onSubject,
                possessivePairs = possessivePairs,
                objectHavePossessive = onObject,
                objectPossessorHavePossessive = onOwner
            )
            SentenceResult(
                hieroglyphs = sentence.hieroglyphs,
                transliteration = sentence.transliteration,
                translationIt = sentence.translationIt,
                translationEn = sentence.translationEn,
                translationDe = sentence.translationDe,
                translationEs = sentence.translationEs,
                translationFr = sentence.translationFr
            )
        }
    }
    if (effectiveAdverbials.isNotEmpty()) {
        addDistinct(10 - sentences.size) {
            buildAdverbialSentenceSync(
                soggettiCount = 1,
                random = random,
                words = words,
                adverbialSentences = effectiveAdverbials,
                subjectHavePossessive = true,
                possessivePairs = possessivePairs
            )
        }
    }

    // Wrong tiles: a few seen words and verbs, plus two possessives that aren't in the sentence
    // (another person, or the same one in the wrong gender or number).
    val possessives = possessiveForms(languageCode)
    return sentences.shuffled(random).map { sentence ->
        val phrase = sentence.translation()
        val bank = buildWordBankFromWords(phrase, words, verbs, languageCode, random, distractorCount = 3)
        val wrongPossessives = possessives
            .filter { form -> bank.none { it.equals(form, ignoreCase = true) } }
            .shuffled(random)
            .take(2)
        WordSelectionContent(
            hieroglyphs = sentence.hieroglyphs,
            correctPhrase = phrase,
            words = (bank + wrongPossessives).shuffled(random),
            transliteration = sentence.transliteration,
            soggettiCount = 1
        )
    }
}
